import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * New pages open at the top. Anchored links (/page#section) scroll to the
 * section instead, and back/forward keeps the browser's own scroll position.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType === "POP") return;

    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      // The target may mount a tick after the route does.
      let tries = 0;
      const find = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (tries++ < 10) {
          timer = setTimeout(find, 80);
        }
      };
      let timer = setTimeout(find, 0);
      return () => clearTimeout(timer);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    return undefined;
  }, [pathname, hash, navType]);

  return null;
}
